// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/Images/whychooseus-bg-image.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homewhyChooseUs_main_container{
    background-color:#012101 ;
    height: 786px;
    padding: 0 50px;
    position: relative;
    color: #ffffff;
}

.hometimely_container{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    height: 450px;
    width: 450px;
    
}

.homewhyChooseUs_head_container{
   display: flex;
   justify-content: space-between;
   align-items: center;
}

.homewhyChooseUs_head{
    width: 402px;
    height: 148px;
}

.homewhyChooseUs_headh6{
    font-weight: 400;
    font-size: 18px;
    line-height: 27.52px;
    color: #EAAD11;
}

.homewhyChooseUs_headp{
    font-weight: 700;
    font-size: 36px;
    line-height: 55px;
}

.homewhyChooseUs_column_container{
    display: flex;
    padding: 100px 0;
    gap: 50px;
    position: absolute;
    top: 270px;
    
}

.homeexpertiseicon_container img{
    width: 40.18px;
    height: 35.18px;
}



.homeexpertise_container{
    width: 377px;
    display: flex;
    gap: 10px;
}


.homeexpertiseh4{
    font-weight: 700;
    font-size: 24px;
    line-height: 33.1px;
    width: 320px;
    height: 33px;
}

.homeexpertise_text{
    font-weight: 400;
    font-size: 16px;
    line-height: 24.46px;
    width: 320px ;
}


/* responsiveness starts here */

@media screen and (max-width: 1050px){
    .homewhyChooseUs_main_container{
        padding: 0 30px;
    }

    .homewhyChooseUs_column_container{
        display: flex;
        padding: 100px 0;
        position: absolute;
        top: 270px;    
    }

    .homeexpertiseicon_container img{
        width: 32.18px;
        height: 35.18px;
    }
     
    .homeexpertise_container{
        width: 270px;
        display: flex;
        gap: 20px;
    }
    
    .homeexpertiseh4{
        font-size: 20px;
    }
    
    .homeexpertise_text{
        font-size: 15px;
        width: 260px ;
    }
}


@media screen and (max-width: 900px){
    .homewhyChooseUs_head{
        width: 380px;
        height: 148px;
    }
    
    .homewhyChooseUs_headh6{
        font-size: 16px;
    }
    
    .homewhyChooseUs_headp{
        font-size: 30px;
    }

    .homeexpertiseicon_container img{
        width: 28.18px;
        height: 32.18px;
    }
    
    
    .homeexpertise_container{
        width: 200px;
        display: flex;
        gap: 10px;
    }
    
    .homeexpertiseh4{
        font-size: 16px;
    }
    
    .homeexpertise_text{
        font-size: 12px;
        width: 195px ;
    }
}


@media screen and (max-width: 500px){

    .homewhyChooseUs_main_container{
        background-color:#012101 ;
        height: 840px;
        padding: 0 20px;
        position: relative;
    }
    
    .hometimely_container{
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        background-position: center bottom;
        background-size: cover;
        background-repeat: no-repeat;
        height: 200px;
        width: 200px;
        margin-top: 380px;
    }
    
    .homewhyChooseUs_head_container{
       display: flex;
       flex-direction: column;
       width: 100%;
    }
    
    .homewhyChooseUs_head{
        width: 360px;
        height: 96px;
        padding-top: 40px;
    }
    
    .homewhyChooseUs_headh6{
        font-weight: 400;
        font-size: 16px;
        line-height: 24.46px;
        color: #EAAD11;
    }
    
    .homewhyChooseUs_headp{
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
    }
    
    .homewhyChooseUs_column_container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 100px 0;
        gap: 50px;
        position: absolute;
        top: 100px;

    }
    
    .homeexpertiseicon_container img{
        width: 30.18px;
        height: 31.18px;
    }
    
    
    .homeexpertise_container{
        width: 100%;
        display: flex;
        gap: 10px;
    }
    
    
    .homeexpertiseh4{
        font-weight: 700;
        font-size: 18px;
        line-height: 24.82px;
        width: 320px;
        height: 33px;
    }
    
    .homeexpertise_text{
        font-weight: 400;
        font-size: 16px;
        line-height: 24.46px;
        width: 320px ;
    }
}

@media screen and (max-width: 380px){
    
    .homewhyChooseUs_main_container{
        height: 800px;
    }
    .homewhyChooseUs_head{
        width: 320px;
    }
    
    .homewhyChooseUs_headh6{
        font-size: 14px;
    }
    
    
    .homeexpertiseicon_container img{
        width: 28.18px;
        height: 31.18px;
    }
    
    
    
    .homeexpertiseh4{
        font-weight: 700;
        font-size: 16px;
        line-height: 24.82px;
        width: 280px;
        height: 33px;
    }
    
    .homeexpertise_text{
        font-weight: 400;
        font-size: 13px;
        line-height: 24.46px;
        width: 280px ;
    }
}


@media screen and (max-width: 330px){
    
    .homewhyChooseUs_main_container{
        height: 860px;
    }

    .homewhyChooseUs_head{
        width: 260px;
    }
    
    .homewhyChooseUs_headh6{
        font-size: 12px;
    }
    
    
    .homeexpertiseicon_container img{
        width: 26.18px;
        height: 30.18px;
    }
    
    
    .homeexpertiseh4{
        font-weight: 700;
        font-size: 16px;
        line-height: 24.82px;
        width: 250px;
        height: 33px;
    }
    
    .homeexpertise_text{
        font-size: 12px;
        width: 220px ;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/WhyChooseUs.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yDAAkE;IAClE,wBAAwB;IACxB,sBAAsB;IACtB,4BAA4B;IAC5B,aAAa;IACb,YAAY;;AAEhB;;AAEA;GACG,aAAa;GACb,8BAA8B;GAC9B,mBAAmB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,UAAU;;AAEd;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;;;AAIA;IACI,YAAY;IACZ,aAAa;IACb,SAAS;AACb;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,aAAa;AACjB;;;AAGA,+BAA+B;;AAE/B;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;AACJ;;;AAGA;IACI;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;;IAGA;QACI,YAAY;QACZ,aAAa;QACb,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;AACJ;;;AAGA;;IAEI;QACI,yBAAyB;QACzB,aAAa;QACb,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,yDAAkE;QAClE,kCAAkC;QAClC,sBAAsB;QACtB,4BAA4B;QAC5B,aAAa;QACb,YAAY;QACZ,iBAAiB;IACrB;;IAEA;OACG,aAAa;OACb,sBAAsB;OACtB,WAAW;IACd;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,gBAAgB;QAChB,SAAS;QACT,kBAAkB;QAClB,UAAU;;IAEd;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;;IAGA;QACI,WAAW;QACX,aAAa;QACb,SAAS;IACb;;;IAGA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,aAAa;IACjB;AACJ;;AAEA;;IAEI;QACI,aAAa;IACjB;IACA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,cAAc;QACd,eAAe;IACnB;;;;IAIA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,aAAa;IACjB;AACJ;;;AAGA;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,cAAc;QACd,eAAe;IACnB;;;IAGA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;AACJ","sourcesContent":[".homewhyChooseUs_main_container{\n    background-color:#012101 ;\n    height: 786px;\n    padding: 0 50px;\n    position: relative;\n    color: #ffffff;\n}\n\n.hometimely_container{\n    background-image: url('../Assets/Images/whychooseus-bg-image.svg');\n    background-position: top;\n    background-size: cover;\n    background-repeat: no-repeat;\n    height: 450px;\n    width: 450px;\n    \n}\n\n.homewhyChooseUs_head_container{\n   display: flex;\n   justify-content: space-between;\n   align-items: center;\n}\n\n.homewhyChooseUs_head{\n    width: 402px;\n    height: 148px;\n}\n\n.homewhyChooseUs_headh6{\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 27.52px;\n    color: #EAAD11;\n}\n\n.homewhyChooseUs_headp{\n    font-weight: 700;\n    font-size: 36px;\n    line-height: 55px;\n}\n\n.homewhyChooseUs_column_container{\n    display: flex;\n    padding: 100px 0;\n    gap: 50px;\n    position: absolute;\n    top: 270px;\n    \n}\n\n.homeexpertiseicon_container img{\n    width: 40.18px;\n    height: 35.18px;\n}\n\n\n\n.homeexpertise_container{\n    width: 377px;\n    display: flex;\n    gap: 10px;\n}\n\n\n.homeexpertiseh4{\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 33.1px;\n    width: 320px;\n    height: 33px;\n}\n\n.homeexpertise_text{\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24.46px;\n    width: 320px ;\n}\n\n\n/* responsiveness starts here */\n\n@media screen and (max-width: 1050px){\n    .homewhyChooseUs_main_container{\n        padding: 0 30px;\n    }\n\n    .homewhyChooseUs_column_container{\n        display: flex;\n        padding: 100px 0;\n        position: absolute;\n        top: 270px;    \n    }\n\n    .homeexpertiseicon_container img{\n        width: 32.18px;\n        height: 35.18px;\n    }\n     \n    .homeexpertise_container{\n        width: 270px;\n        display: flex;\n        gap: 20px;\n    }\n    \n    .homeexpertiseh4{\n        font-size: 20px;\n    }\n    \n    .homeexpertise_text{\n        font-size: 15px;\n        width: 260px ;\n    }\n}\n\n\n@media screen and (max-width: 900px){\n    .homewhyChooseUs_head{\n        width: 380px;\n        height: 148px;\n    }\n    \n    .homewhyChooseUs_headh6{\n        font-size: 16px;\n    }\n    \n    .homewhyChooseUs_headp{\n        font-size: 30px;\n    }\n\n    .homeexpertiseicon_container img{\n        width: 28.18px;\n        height: 32.18px;\n    }\n    \n    \n    .homeexpertise_container{\n        width: 200px;\n        display: flex;\n        gap: 10px;\n    }\n    \n    .homeexpertiseh4{\n        font-size: 16px;\n    }\n    \n    .homeexpertise_text{\n        font-size: 12px;\n        width: 195px ;\n    }\n}\n\n\n@media screen and (max-width: 500px){\n\n    .homewhyChooseUs_main_container{\n        background-color:#012101 ;\n        height: 840px;\n        padding: 0 20px;\n        position: relative;\n    }\n    \n    .hometimely_container{\n        background-image: url('../Assets/Images/whychooseus-bg-image.svg');\n        background-position: center bottom;\n        background-size: cover;\n        background-repeat: no-repeat;\n        height: 200px;\n        width: 200px;\n        margin-top: 380px;\n    }\n    \n    .homewhyChooseUs_head_container{\n       display: flex;\n       flex-direction: column;\n       width: 100%;\n    }\n    \n    .homewhyChooseUs_head{\n        width: 360px;\n        height: 96px;\n        padding-top: 40px;\n    }\n    \n    .homewhyChooseUs_headh6{\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24.46px;\n        color: #EAAD11;\n    }\n    \n    .homewhyChooseUs_headp{\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 32px;\n    }\n    \n    .homewhyChooseUs_column_container{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        padding: 100px 0;\n        gap: 50px;\n        position: absolute;\n        top: 100px;\n\n    }\n    \n    .homeexpertiseicon_container img{\n        width: 30.18px;\n        height: 31.18px;\n    }\n    \n    \n    .homeexpertise_container{\n        width: 100%;\n        display: flex;\n        gap: 10px;\n    }\n    \n    \n    .homeexpertiseh4{\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 24.82px;\n        width: 320px;\n        height: 33px;\n    }\n    \n    .homeexpertise_text{\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24.46px;\n        width: 320px ;\n    }\n}\n\n@media screen and (max-width: 380px){\n    \n    .homewhyChooseUs_main_container{\n        height: 800px;\n    }\n    .homewhyChooseUs_head{\n        width: 320px;\n    }\n    \n    .homewhyChooseUs_headh6{\n        font-size: 14px;\n    }\n    \n    \n    .homeexpertiseicon_container img{\n        width: 28.18px;\n        height: 31.18px;\n    }\n    \n    \n    \n    .homeexpertiseh4{\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 24.82px;\n        width: 280px;\n        height: 33px;\n    }\n    \n    .homeexpertise_text{\n        font-weight: 400;\n        font-size: 13px;\n        line-height: 24.46px;\n        width: 280px ;\n    }\n}\n\n\n@media screen and (max-width: 330px){\n    \n    .homewhyChooseUs_main_container{\n        height: 860px;\n    }\n\n    .homewhyChooseUs_head{\n        width: 260px;\n    }\n    \n    .homewhyChooseUs_headh6{\n        font-size: 12px;\n    }\n    \n    \n    .homeexpertiseicon_container img{\n        width: 26.18px;\n        height: 30.18px;\n    }\n    \n    \n    .homeexpertiseh4{\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 24.82px;\n        width: 250px;\n        height: 33px;\n    }\n    \n    .homeexpertise_text{\n        font-size: 12px;\n        width: 220px ;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
